import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";

import { Button } from "../Buttons";

import "./tripleGrid.scss";

function TripleGrid({
  title,
  legend,
  children,
  viewType,
  customClassName,
  ifPagination,
  paginationClick,
}) {
  const { t } = useTranslation();
  const tripleGridClasses = classNames({
    tripleGrid: true,
    wideGrid: viewType === "wide",
    middleGrid: viewType === "middle",
    [customClassName]: customClassName,
  });

  return (
    <section className={tripleGridClasses}>
      <h2>{title}</h2>
      {legend && <legend className="tripleGridLegend">{legend}</legend>}
      <ul className="tripleGridList">{children}</ul>
      {ifPagination && (
        <div className="paginationBtnBlock">
          <Button
            viewType="cancelBtn"
            label={t("viewMore")}
            onClick={() => paginationClick()}
          />
        </div>
      )}
    </section>
  );
}

TripleGrid.propTypes = {
  viewType: PropTypes.oneOf(["wide", "middle"]),
  title: PropTypes.string,
  legend: PropTypes.string,
  ifPagination: PropTypes.bool,
  customClassName: PropTypes.string,
  paginationClick: PropTypes.func,
};

TripleGrid.defaultProps = {
  title: "",
  legend: "",
  children: "",
  customClassName: "",
  ifPagination: false,
};

export default TripleGrid;
